import _Abstract from "system/abstract"

export default class Component_HeaderDesktop extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {
    }, options), 'component')
this.bindEvents()
  }

  bindEvents() {
    // this.$el.find(".b-header__top-nav-list--products > a").click((e) => this.onProductsClicked(e));
    // this.$el.find(".b-header__top-nav-list--learn > a").click((e) => this.onLearnClicked(e));
    // this.$el.find(".b-header__top-nav-list--contact > a").click((e) => this.onContactClicked(e));
    this.$el.find(".b-header__top-nav-list--products > a").mouseenter((e) => this.onProductsHovered(e));
    this.$el.find(".b-header__top-nav-list--learn > a").mouseenter((e) => this.onLearnHovered(e));
    this.$el.find(".b-header__top-nav-list--contact > a").mouseenter((e) => this.onContactHovered(e));
 
    // this.$el.find(".b-header__top-nav-list--products").mouseleave((e) => this.onHideProductsHovered(e));
    // this.$el.find(".b-header__top-nav-list--learn").mouseleave((e) => this.onHideLearnHovered(e));
    // this.$el.find(".b-header__top-nav-list--contact").mouseleave((e) => this.onHideContactHovered(e));

    // this.$el.find(".b-header__our-products-desktop-top-navigation").mouseleave((e) => this.onTopNavigationMouseLeave(e));

    this.$el.find(".b-header__top-nav-list--products").mouseleave((e) => this.onProductMouseLeave(e));
    this.$el.find(".b-header__top-nav-list--learn").mouseleave((e) => this.onLearnMouseLeave(e));
    this.$el.find(".b-header__top-nav-list--contact").mouseleave((e) => this.onContactMouseLeave(e));

    this.$el.find(".b-header__top-nav-list--search").click((e) => this.onSearchIconClicked(e));
    this.$el.find(".c-search-input form").submit((e) => this.onSearchFormSubmitted(e));

    this.$el.find(".b-header-content__dropdown").click((e) => this.onCountryDropdownClicked(e));
    this.$el.find(".b-header-content__dropdown-menu-list-item").click((e) => this.onCountryDropdownListClicked(e));


    this.$el.find(".b-header__our-products-desktop-left-navigation > a").click((e) => this.onProductsDesktopLeftNavigationClicked(e));
    this.$el.find(".b-header__top-nav-list--bg").click((e) => this.onProductsDesktopLeftNavigationClicked(e));

    $(".b-header .c-search-input--input").keyup((e) => this.onSearchInputKeyUp(e));

    var userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    if (isTablet) {
      if (window.matchMedia('(max-device-width : 1366px) and (orientation : landscape)').matches) {
        this.$el.find(".b-header__top-nav-list--products > a").click((e) => this.onProductsClicked(e));
        this.$el.find(".b-header__top-nav-list--learn > a").click((e) => this.onLearnClicked(e));
        this.$el.find(".b-header__top-nav-list--contact > a").click((e) => this.onContactClicked(e));
      } else {
        this.loadWindowOnResize();
      }
    }

    this.searchInputPushDownOnSearchResultsPage();
    $('body').click((e) => this.bodyClicked(e));
  }

  bodyClicked(_event){
    if(!$('.b-header-content__dropdown-menu-wrapper').hasClass('-hidden'))
      {
    $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden')
    $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen')
      }
  }

  onCountryDropdownClicked(_event){
    _event.stopPropagation()
    if($('.b-header-content__dropdown-menu-wrapper').hasClass('-hidden'))
      {
        $('.b-header-content__dropdown-wrapper').addClass('-dropdownopen')
      $('.b-header-content__dropdown-menu-wrapper').removeClass('-hidden')
      } else {
        $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen')
        $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden')
      }
    
  }

  onCountryDropdownListClicked(_event) {
    _event.stopPropagation()
    $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden')
    $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen')
  }


  onProductsClicked(_mouseEvent) {
    _mouseEvent.preventDefault();
    var $productsNavElement = this.$el.find(".b-header__top-nav-list--products");
    if ($productsNavElement.hasClass("-expanded")) {
      this.hideProductsItems();
    }
    else {
      // if($("html").hasClass("no-touch"))
      // {
      //   //Will roll over instead
      //   return;
      // }
      this.showProductsItems();
    }
    // var $productsSideNavElem = $(".sub-nav-items.-products");
    // if($productsSideNavElem.hasClass("-hide")) {
    //   $productsSideNavElem.removeClass("-hide");
    // } else {
    //   $productsSideNavElem.addClass("-hide");
    // }
  }

  onLearnClicked(_mouseEvent) {
    _mouseEvent.preventDefault();
    var $learnNavElement = this.$el.find(".b-header__top-nav-list--learn");
    if ($learnNavElement.hasClass("-expanded")) {
      this.hideLearnItems();
    }
    else {
      // if($("html").hasClass("no-touch"))
      // {
      //   //Will roll over instead
      //   return;
      // }
      this.showLearnItems();
    }
    // var $learnSideNavElem = $(".sub-nav-items.-learn");
    // if($learnSideNavElem.hasClass("-hide")) {
    //   $learnSideNavElem.removeClass("-hide");
    // } else {
    //   $learnSideNavElem.addClass("-hide");
    // }
  }

  onContactClicked(_mouseEvent) {
    _mouseEvent.preventDefault();
    var $productsNavElement = this.$el.find(".b-header__top-nav-list--contact");
    if ($productsNavElement.hasClass("-expanded")) {
      this.hideContactItems();
    }
    else {
      // if($("html").hasClass("no-touch"))
      // {
      //   //Will roll over instead
      //   return;
      // }
      this.showContactItems();
    }
  }

  onSearchInputKeyUp(_keyEvent) {
    switch (_keyEvent.keyCode) {
      case 13: //enter
        {
          if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
          }

          // this.onEnterPressed(_keyEvent);
          var searchTerm = encodeURIComponent(_keyEvent.target.value);
          var navigationLocation = window.location.origin + "/search?searchtext=" + searchTerm + "&searchmode=anyword";
          window.location.href = navigationLocation;
          break;
        }
    }
  }

  onProductsHovered(_mouseEvent) {
    this.showProductsItems();
    this.onSubNavSearchItemClosed();
  }

  onLearnHovered(_mouseEvent) {
    this.showLearnItems();
    this.onSubNavSearchItemClosed();
  }

  onContactHovered(_mouseEvent) {
    this.showContactItems();
    this.onSubNavSearchItemClosed();
  }

  onHideProductsHovered(_mouseEvent) {
    this.hideProductsItems();
  }

  onHideLearnHovered(_mouseEvent) {
    this.hideLearnItems();
  }

  onHideContactHovered(_mouseEvent) {
    this.hideContactItems();
  }

  onSearchIconClicked(_mouseEvent) {
    var $topNavListSearch = this.$el.find(".b-header__top-nav-list--search");

    if ($topNavListSearch.hasClass("-expanded")) {
      //Close it
      $topNavListSearch.removeClass("-expanded");
      this.$el.find(".c-search-input").addClass("-hide");
      this.onSubNavItemClosed();
    }
    else {

      //Open it
      this.closeAllTopNavItems();
      $topNavListSearch.addClass("-expanded");
      this.showSubNavItem(".c-search-input");


      this.$el.find(".c-search-input--input").focus();
    }
  }



  onProductMouseLeave(_mouseEvent) {


    if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
      return;
    }

    this.hideProductsItems();
  }

  onLearnMouseLeave(_mouseEvent) {


    if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
      return;
    }

    this.hideLearnItems();
  }

  onContactMouseLeave(_mouseEvent) {


    if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
      return;
    }

    this.hideContactItems();
  }

  showLearnItems() {
    this.closeAllTopNavItems();
    this.$el.find(".b-header__top-nav-list--learn").addClass("-expanded");
    this.showSubNavItem(".b-header__top-nav-list--learn-items");
  }

  hideLearnItems() {
    this.$el.find(".b-header__top-nav-list--learn").removeClass("-expanded");
    this.$el.find(".b-header__top-nav-list--learn-items").addClass("-hide");
    this.onSubNavItemClosed();
  }

  showProductsItems() {
    this.closeAllTopNavItems();
    this.$el.find(".b-header__top-nav-list--products").addClass("-expanded");
    this.showSubNavItem(".b-header__top-nav-list--products-items");
  }

  hideProductsItems() {
    this.$el.find(".b-header__top-nav-list--products").removeClass("-expanded");
    this.$el.find(".b-header__top-nav-list--products-items").addClass("-hide");
    this.onSubNavItemClosed();
  }

  showContactItems() {
    this.closeAllTopNavItems();
    this.$el.find(".b-header__top-nav-list--contact").addClass("-expanded");
    this.showSubNavItem(".b-header__top-nav-list--contact-items");
  }

  hideContactItems() {
    this.$el.find(".b-header__top-nav-list--contact").removeClass("-expanded");
    this.$el.find(".b-header__top-nav-list--contact-items").addClass("-hide");
    this.onSubNavItemClosed();
  }

  closeAllTopNavItems() {
    this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
  }


  showSubNavItem(_selector) {
    var $subNavItem = $(_selector);
    if (!$subNavItem.length) {
      console.log("sub nav item not found with " + _selector + " selector");
      return;
    }

    this.onSubNavItemOpened();
    this.$el.find(".sub-nav-items > *").addClass("-hide");
    $subNavItem.removeClass("-hide");
  }

  onSubNavItemOpened() {
    this.$el.find(".sub-nav-items").removeClass("-hide");
  }

  onSubNavItemClosed() {
    this.$el.find(".sub-nav-items").addClass("-hide");
    this.$el.find(".c-search-input__results").addClass("-hide");
    //this.$el.find(".c-search-input--input").val("");
  }

  onSubNavSearchItemClosed() {
    this.$el.find(".c-search-input").addClass("-hide");
    //this.$el.find(".c-search-input--input").val("");
  }

  onSearchInputFocused(_mouseEvent) {
    $(window).scrollTop(0);
    this.$el.addClass("-search-input-focused");

  }
  onSearchInputFocusOut(_mouseEvent) {
    $(window).scrollTop(0);
    this.$el.removeClass("-search-input-focused");

  }

  onSearchFormSubmitted(_formSubmitEvent) {
    _formSubmitEvent.preventDefault();
    _formSubmitEvent.stopPropagation();

    this.$el.find(".c-search-input__results").removeClass("-hide");
  }

  onProductsDesktopLeftNavigationClicked(_mouseEvent) {
    var $leftNavigationElement = this.$el.find(".b-header__our-products-desktop-left-navigation");
    if (!$leftNavigationElement.length) {
      console.log("Could not find Left Navigation");
      return;
    }

    if ($leftNavigationElement.hasClass("-expanded")) {
      $leftNavigationElement.removeClass("-expanded");
      // $("body").removeAttr("style");
    }
    else {
      $leftNavigationElement.addClass("-expanded");
      // $("body").css("overflow","hidden");
    }
  }


  onDesktopOnlySearchClicked(_mouseEvent) {
    console.log("onDesktopOnlySearchClicked")
    if (this.$el.hasClass("-child-nav-li-expanded")) {
      this.$el.find(".c-search-input.-desktop-only").removeClass("-hide");
    }
  }

  loadWindowOnResize() {
    $(window).resize(function (event) {
      console.log($('Resizd'))
      this.location.reload();
    });
  }

  searchInputPushDownOnSearchResultsPage() {
    if($('.content-margin').hasClass('furnware-search-results')) {
      $('.b-header__our-products-desktop-top-navigation').addClass('-push-search-results');
    } else {
      $('.b-header__our-products-desktop-top-navigation').removeClass('-push-search-results');
    }
  }

}





/** WEBPACK FOOTER **
 ** ./components/header-desktop.js
 **/